export default __webpack_public_path__ + "static/media/dgm03-data-governance-implementation_service-offering_2239(2015).f0b8d2d3.pdf";